import { render, staticRenderFns } from "./WrapperVStepperStep.vue?vue&type=template&id=45d361cc"
import script from "./WrapperVStepperStep.vue?vue&type=script&lang=js"
export * from "./WrapperVStepperStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports